import { COMPLIANCE_PATH } from '../constants';

export const COMPLIANCE_REGISTRY_PATH = `${COMPLIANCE_PATH}/policies`;
export const COMPLIANCE_MD_EDITOR_PATH = `${COMPLIANCE_REGISTRY_PATH}/md-editor`;
export const COMPLIANCE_MD_EDITOR_FINALIZE_PATH = `${COMPLIANCE_REGISTRY_PATH}/md-editor/finalize`;
